import axiosHttpRequest from "../axios";

async function customerWOList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function customerWODetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;

  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function customerWORouteDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  return listViewData;
}
async function sftoRouteDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function sftoRakeDetailslist(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function createJobService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}
async function sftojobheaderDetailslist(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;

  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
  // return serviceResponse;
}

async function sftoJobOriginDetailsSaveService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    null,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function sftoOriginExamExcelParseService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execMultiPartRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}


async function sftojobheaderDetailslistbyjobid(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;

  return listViewData;
}
async function sftoOriginDetailsbyjobidService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  //console.log("Service Response", serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;

  return listViewData;
}
async function approveJobService(endpoint, param, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function saveRouteService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function saveSftoLoadingPointsService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoIntermediateStationsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function getSftoRouteslistService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;

  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}
async function getSftoLoadingPointsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function sftoWagonExcelParseService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execMultiPartRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function sftoCalculateFeeService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function saveSftoWagondetailsService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoWagondetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoRRService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoRRService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoRROtherdetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoRROtherdetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoRouteFinalisationdetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoRouteFinalisationdetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoIntransitdetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoIntransitdetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoDestinationdetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoDestinationdetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoReturndetailsService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getSftoReturndetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function saveSftoCommercialDetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function generateSftoPackinglistService(
  endpoint,
  configheaders,
  postdata
) {
  const serviceResponse = await axiosHttpRequest.execPostRequestsDownloadFile(
    endpoint,
    "Packinglist.pdf",
    configheaders,
    postdata
  );
}

async function generateSftoDestinationmemoService(
  endpoint,
  configheaders,
  postdata
) {
  const serviceResponse = await axiosHttpRequest.execPostRequestsDownloadFile(
    endpoint,
    "SFTODestmatiomemo.pdf",
    configheaders,
    postdata
  );
}

async function getOriginsListService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  //console.log(serviceResponse);
  let serviceData = serviceResponse.data;

  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getDestinationsListService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  )
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function downloadDashboardJobDetailsService(endpoint, filename, configheaders, queryparams) {
  axiosHttpRequest.execGetRequestsWithParamsDownloadFile(endpoint, filename, configheaders, queryparams)
}
async function downloadReports(endpoint, filename, configheaders, postdata) {
  axiosHttpRequest.execPostRequestsDownloadFile1(endpoint, postdata, filename, configheaders)
}

async function downloadConsolidatedInvoicePdf(endpoint, filename, configheaders, postdata) {
  axiosHttpRequest.execPostRequestsDownloadFile1(endpoint, postdata, filename, configheaders)
}
async function downloadSftoJobDetailsReport(endpoint, filename, configheaders, postdata) {
  axiosHttpRequest.execPostRequestsDownloadFile1(endpoint, postdata, filename, configheaders)
}

async function uploadFileForDetails(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function createEmptyJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function createIRJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function createMaintainanceJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function updateEmptyJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    null,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function updateMaintainanceJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    null,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function updateIRJobService(endpoint, postdata, configheaders){
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    null,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function saveSftoContractdetailsService(
  endpoint,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    null,
    postdata,
    configheaders
  );
  return serviceResponse;
}

export default {
  downloadConsolidatedInvoicePdf,
  customerWOList,
  customerWODetails,
  customerWORouteDetails,
  sftoRouteDetails,
  sftoRakeDetailslist,
  createJobService,
  sftojobheaderDetailslist,
  sftojobheaderDetailslistbyjobid,
  sftoJobOriginDetailsSaveService,
  sftoOriginDetailsbyjobidService,
  approveJobService,
  getSftoIntermediateStationsService,
  getSftoRouteslistService,
  saveRouteService,
  saveSftoLoadingPointsService,
  getSftoLoadingPointsService,
  sftoWagonExcelParseService,
  sftoCalculateFeeService,
  saveSftoWagondetailsService,
  getSftoWagondetailsService,
  saveSftoRRService,
  getSftoRRService,
  saveSftoRROtherdetailsService,
  getSftoRROtherdetailsService,
  getSftoRouteFinalisationdetailsService,
  saveSftoRouteFinalisationdetailsService,
  saveSftoIntransitdetailsService,
  getSftoIntransitdetailsService,
  saveSftoDestinationdetailsService,
  getSftoDestinationdetailsService,
  saveSftoReturndetailsService,
  getSftoReturndetailsService,
  saveSftoCommercialDetailsService,
  generateSftoPackinglistService,
  generateSftoDestinationmemoService,
  sftoOriginExamExcelParseService,
  getOriginsListService,
  getDestinationsListService,
  downloadDashboardJobDetailsService,
  downloadReports,
  downloadSftoJobDetailsReport,
  uploadFileForDetails,
  createEmptyJobService,
  updateEmptyJobService,
  createMaintainanceJobService,
  updateMaintainanceJobService,
  createIRJobService,
  updateIRJobService,
  saveSftoContractdetailsService
};
